import { type ComponentType, createElement } from 'react';

interface CustomToolbarSlotProps {
	component?: ComponentType<any>;
	componentProps?: Record<string, any>;
}

declare module '@mui/x-data-grid' {
	interface ToolbarPropsOverrides extends CustomToolbarSlotProps {}
}

/** Keep a stable grid slot while passing each custom toolbar its own typed props. */
export function GridToolbarSlot({ component, componentProps }: CustomToolbarSlotProps) {
	return component ? createElement(component, componentProps) : null;
}

export function gridToolbarProps<Props extends object>(component: ComponentType<Props>, componentProps: Props) {
	return { component, componentProps };
}
